import {BASE_API} from "../index";

export const UserApi = {
  login: async (username, password) => {
    let response = await fetch(`${BASE_API}/login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(
        {
          username,
          password
        }
      )
    })
    return await response.json();
  },

  decode: async (token) => {
    let response = await fetch(`${BASE_API}/decode`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Token': token
      }
    });

    return await response.json();
  },

  getFuncionarios: async (user_uuid) => {
    let response = await fetch(`${BASE_API}/user/getfuncionarios`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify(
        {
          user_uuid
        }
      )
    })

    return await response.json();
  },

  getAllUser: async (user_uuid, pagina) => {
    let response = await fetch(`${BASE_API}/user`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify({
        user_uuid,
        pagina
      })
    })

    return await response.json();
  },

  getAllUserSearch: async (user_uuid, pagina, search) => {
    let response = await fetch(`${BASE_API}/user?search=${search}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify({
        user_uuid,
        pagina
      })
    })

    return await response.json();
  },

  getUser: async (user_uuid, get_uuid) => {
    let response = await fetch(`${BASE_API}/user/getuser`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify({
        user_uuid,
        get_uuid
      })
    })

    return await response.json();
  },

  create: async (user_uuid, nome, cpf, matricula, imagem, funcao, loja) => {
    let formData = new FormData();
    formData.append('user_uuid', user_uuid);
    formData.append('nome', nome);
    formData.append('cpf', cpf);
    formData.append('matricula', matricula);
    formData.append('funcao', funcao);
    formData.append('loja', loja);
    if (imagem) {
      formData.append('imagem', imagem);
    }

    let response = await fetch(`${BASE_API}/user/create`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })

    return await response.json();
  },

  update: async (user_uuid, update_uuid, nome, cpf, matricula, imagem, funcao, loja) => {
    let formData = new FormData();
    formData.append('user_uuid', user_uuid);
    formData.append('update_uuid', update_uuid);
    formData.append('nome', nome);
    formData.append('cpf', cpf);
    formData.append('matricula', matricula);
    formData.append('funcao', funcao);
    formData.append('loja', loja);
    if (imagem) {
      formData.append('imagem', imagem);
    }

    let response = await fetch(`${BASE_API}/user/update`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })

    return await response.json();
  },

  updateSenha: async (user_uuid, update_uuid, senhaNova) => {
    let response = await fetch(`${BASE_API}/user/updatesenha`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify(
        {
          user_uuid,
          update_uuid,
          senhaNova
        }
      )
    })

    return await response.json();
  },

  resetSenha: async (user_uuid, update_uuid) => {
    let response = await fetch(`${BASE_API}/user/resetsenha`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify(
        {
          user_uuid,
          update_uuid
        }
      )
    })

    return await response.json();
  },

  toggleStatus: async (user_uuid, update_uuid) => {
    let response = await fetch(`${BASE_API}/user/togglestatus`, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: JSON.stringify(
        {
          user_uuid,
          update_uuid
        }
      )
    })

    return await response.json();
  }
}